import { PolicyMeta } from "./PolicyMeta";
const SystemPolicies = [
  "drives",
  "cancellations",
  "notifications",
  "events",
  "courses",
  "payratios",
  "billing",
  "calendar",
  "storefront",
  "branding",
  "onlinedriversed",
  "studentmetadata",
  "documents",
  "scheduling",
  "activity",
];

class Policy {
  constructor(id, name, meta = []) {
    this.$id = id;
    if (SystemPolicies.includes(name) === false) {
      //hrow new Error(`Invalid Policy name: ${name}`);
      console.log(`Invalid Policy name: ${name}`);
    }
    this.$name = name;

    this.$meta = meta;
  }

  /**
   * @returns {number}
   */
  id() {
    return this.$id;
  }

  /**
   * @returns {string}
   */
  name() {
    return this.$name;
  }

  /**
   * @returns {Array<PolicyMeta>}
   */
  meta() {
    return this.$meta;
  }

  /**
   * @param {Array<PolicyMeta>} data
   */
  setMetaData(data = []) {
    this.$meta = [].concat([...data]);
  }

  /**
   * @param {string} key
   * @returns {any}
   */
  getMetaValueByKey(key = "") {
    const policyMeta = this.$meta.filter((meta) => {
      return meta.key() === key;
    });

    if (policyMeta.length === 0) {
      throw Error(`Meta key with name ${key} was not found.`);
    }

    return policyMeta[0].value();
  }

  /**
   * Set meta value by key
   * @param {string} key
   * @param {any} value
   */
  setMetaValueByKey(key, value) {
    const policyMeta = this.$meta.filter((meta) => {
      return meta.key() === key;
    });

    if (policyMeta.length === 0) {
      const $meta = new PolicyMeta(0, this.id(), key, value);
      this.setMetaData([...this.meta(), $meta]);
    } else {
      policyMeta[0].setValue(value);
      const $meta = policyMeta[0];
      const $metaCollection = this.meta().filter((m) => {
        return m.key() !== key;
      });
      this.setMetaData([...$metaCollection, $meta]);
    }
  }

  /**
   * @param {string} key
   * @returns {boolean}
   */
  metaExistsByKey(key = "") {
    const policyMeta = this.$meta.filter((meta) => {
      return meta.key() === key;
    });

    if (policyMeta.length === 0) {
      return false;
    }

    return true;
  }
}

export { Policy };
